import {
  faBug,
  faPlusCircle,
  faStar,
  faTools
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ListGroup, Modal } from 'react-bootstrap';

const NewReleaseModal = ({ show, handleClose }) => {
  const newFeatures = [
    {
      title: 'Modelos de Mensagens',
      description:
        'Agora é possível criar modelos de mensagens para agilizar a criação de notas, e-mails, apontamentos e descrições de tickets. Para configurar, acesse Configurações > Modelos de Mensagens.',
      highlight: true
    },
    {
      title: 'Gestão de Produtos e Serviços',
      description:
        'Faça o cadastro dos seus produtos e serviços faturáveis para um melhor gerenciamento de faturamento. Para configurar, acesse Configurações > Produtos e Serviços.'
    },
    {
      title: 'Lançamento de Itens Faturáveis no Ticket',
      description:
        'Após cadastrar os produtos e serviços faturáveis, você poderá lançar itens faturáveis no ticket, facilitando o gerenciamento de faturamento.',
      highlight: true
    },
    {
      title: 'Controle de Faturamento',
      description:
        'Em uma única tela, analise o total de itens lançados e controle o que você cobrará do cliente. Acesse o menu Faturamento.',
      highlight: true
    },
    {
      title: 'Assinatura do agente no e-mail',
      description:
        'Agora é possível adicionar a assinatura do agente no e-mail de resposta do ticket. Para configurar, acesse Configurações > Agentes.',
      highlight: true
    },
    {
      title: 'Envio de e-mail pela caixa de e-mail',
      description:
        'Agora é possível enviar e-mails pela caixa de e-mail configurada. Para configurar, acesse Configurações > Caixas de E-mail.',
      highlight: true
    },
    {
      title: 'Assunto e propriedades automáticas por subcategoria',
      description:
        'Agora é possível definir assunto e propriedades padrão do ticket por subcategoria do catálogo. Ao selecionar a subcategoria na criação do ticket, os campos Assunto, Descrição, Tipo do Ticket e Prioridade são preenchidos automaticamente.',
      highlight: true
    },
    {
      title: 'Edição de assinatura no perfil do agente',
      description:
        'Os agentes agora podem editar e personalizar sua assinatura diretamente no perfil, que será utilizada nas respostas por e-mail.',
      highlight: true
    },
    {
      title: 'Novos campos na tela de apontamento',
      description:
        'A tela de apontamentos foi remodelada e agora permite informar hora de início e hora de fim, calculando automaticamente o tempo gasto em apontamentos e pausas.',
      highlight: true
    }
  ];

  const improvements = [
    {
      title: 'Seleção de cliente em tickets agendados',
      description:
        'Foi corrigida a limitação de listagem de clientes no seletor de tickets agendados. Agora, além da paginação, é possível pesquisar o cliente pelo nome para facilitar a seleção.',
      highlight: true
    },
    {
      title: 'Suporte a caixas de e-mail compartilhadas',
      description:
        'A integração com o Office 365 foi aprimorada para oferecer suporte completo a caixas de correio compartilhadas, melhorando a leitura e envio de e-mails.',
      highlight: true
    },
    {
      title: 'Validação de e-mail entre agente e portal do cliente',
      description:
        'Foi adicionada uma nova validação para impedir o uso do mesmo e-mail entre agentes e usuários do portal do cliente.'
    }
  ];

  const bugFixes = [
    {
      title: 'Correção no login do sistema',
      description:
        'Foram realizadas correções internas no processo de login, aumentando a estabilidade e confiabilidade da autenticação.'
    },
    {
      title:
        'Bloqueio de conclusão de ticket com campos obrigatórios pendentes',
      description:
        'Agora não é mais possível concluir um ticket sem preencher todos os campos obrigatórios. A validação ocorre com destaque visual em vermelho nos campos pendentes.',
      highlight: true
    },
    {
      title: 'Datas incorretas na listagem de tickets do cliente',
      description:
        'Corrigido erro na exibição de datas na listagem de tickets dos detalhes do cliente, ajustando o tipo de dado para garantir precisão de fuso horário.'
    },
    {
      title: 'Erro ao criar novo usuário no tenant',
      description:
        'Corrigido erro que impedia a criação de novos usuários devido ao tamanho da assinatura, ajustando o tipo da coluna para suportar textos maiores.'
    },
    {
      title: 'Envio de e-mails white-label',
      description:
        'Corrigido problema no envio de notificações de tickets, integrando corretamente a funcionalidade de caixas de e-mail configuradas.'
    },
    {
      title: 'Validação ao salvar e pausar tickets',
      description:
        'Agora não é permitido utilizar a ação de "Salvar e Pausar" quando o ticket já estiver em andamento, garantindo maior consistência no fluxo.'
    }
  ];

  const renderList = (items, icon, colorClass) =>
    items.map((item, idx) => (
      <ListGroup.Item
        key={idx}
        variant={item.highlight ? 'success' : ''}
        className="d-flex flex-column"
      >
        <div className="d-flex align-items-center mb-1">
          <FontAwesomeIcon icon={icon} className={`me-2 ${colorClass}`} />
          <strong className="me-2">{item.title}</strong>
          {item.highlight && (
            <FontAwesomeIcon
              icon={faStar}
              className="text-warning ms-auto"
              title="Destaque"
            />
          )}
        </div>
        <small className="text-muted fst-italic">{item.description}</small>
      </ListGroup.Item>
    ));

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="me-2 fw-bold">Notas da Nova Versão</Modal.Title>
        <span className="text-muted fs-10 text-end">16/01/2026</span>
      </Modal.Header>
      <Modal.Body>
        <h5>
          <FontAwesomeIcon icon={faPlusCircle} className="me-2 text-success" />
          Novas funcionalidades
        </h5>
        <ListGroup className="mb-4">
          {renderList(newFeatures, faPlusCircle, 'text-success')}
        </ListGroup>

        <h5>
          <FontAwesomeIcon icon={faTools} className="me-2 text-warning" />
          Melhorias
        </h5>
        <ListGroup className="mb-4">
          {renderList(improvements, faTools, 'text-warning')}
        </ListGroup>

        <h5>
          <FontAwesomeIcon icon={faBug} className="me-2 text-danger" />
          Correções de erros
        </h5>
        <ListGroup>{renderList(bugFixes, faBug, 'text-danger')}</ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewReleaseModal;
